import { render, staticRenderFns } from "./tabPerpanjang.vue?vue&type=template&id=0b2be798"
import script from "./tabPerpanjang.vue?vue&type=script&lang=js"
export * from "./tabPerpanjang.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports